import { render, staticRenderFns } from "./ed-form.vue?vue&type=template&id=17870b9a&"
import script from "./ed-form.ts?vue&type=script&lang=js&"
export * from "./ed-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports